/* eslint-disable import/no-cycle */
import { all, fork } from 'redux-saga/effects';
import alerta from './alertas/alerta';
import analise from './alertas/analise';
import audiencia from './alertas/audiencia';
import daca from './daca';
import dadoParametrizado from './alertas/dadoParametrizado';
import download from './comum/download';
import geo from './alertas/geo';

export default function* rootSaga() {
	yield all([
		fork(alerta),
		fork(daca),
		fork(dadoParametrizado),
		fork(audiencia),
		fork(analise),
		fork(geo),
		fork(download),
	]);
}
